<div class="container">

  <div class="content">
    <router-outlet />
  </div>

  <div class="footer-text">
    {{footerText}}
  </div>
</div>

